import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { BaseComponent } from '../base/base/base.component';
import { ReportService } from '@services/report.service';
import { ReportSummary } from '@models/report-summary';
import { AccountService } from '@services/account.service';
import { Account } from '@models/account';
import { firstValueFrom } from 'rxjs';

class ReportSelection {
    report: ReportSummary;
    isSelected: boolean;
}

@Component({
    selector: 'cp-account-maintenance',
    templateUrl: './account-maintenance.component.html',
    styleUrls: ['./account-maintenance.component.less'],
    standalone: false
})
export class AccountMaintenanceComponent extends BaseComponent implements OnInit {
    @ViewChild(MatPaginator) accountPaginator: MatPaginator;
    @ViewChild(MatPaginator) reportPaginator: MatPaginator;

    accountDataSource: MatTableDataSource<Account>;
    reportDataSource: MatTableDataSource<ReportSelection>;

    allReports: ReportSummary[] = [];
    reports: ReportSelection[] = [];
    accounts: Account[] = [];
    currentAccount: Account;

    searchTerm: string = '';
    noResultsFound: boolean = false;

    accountDisplayColumns: string[] = ['accountNumber', 'accountName', 'accountLocation'];
    reportDisplayColumns: string[] = ['reportSelected', 'reportName', 'reportDescription'];

    get isAccountSelected(): boolean {
        return this.currentAccount !== null && this.currentAccount !== undefined;
    }

    constructor(
        private _accountService: AccountService,
        private _reportService: ReportService
    ) {
        super();
    }

    async ngOnInit(): Promise<void> {
        await this.initialize();
    }

    private async initialize(): Promise<void> {
        this._accountService.getAccountList().subscribe({
            next: (accounts: Account[]) => {
                this.accounts = accounts;
                this.accountDataSource = new MatTableDataSource<Account>(this.accounts);
                this.accountDataSource.paginator = this.accountPaginator;
            },
            error: (error) => {
                console.error('Error fetching reports:', error);
                this.handleError(error);
            }
        });

        await firstValueFrom(this._reportService.getReportList())
            .then((reports: ReportSummary[]) => {
                this.allReports = reports;
                reports.forEach(report => { this.reports.push({ report: report, isSelected: false }); });
                this.reportDataSource = new MatTableDataSource<ReportSelection>(this.reports);
                this.reportDataSource.paginator = this.reportPaginator;
            })
            .catch((error) => {
                console.error('Error fetching reports:', error);
                this.handleError(error);
            }
        );
    }

    onSearch(): void {
        this.noResultsFound = false;
        const searchTermLower = this.searchTerm.toLowerCase();
        const matchingAccounts = this.accounts.filter(account =>
            account.AccountNumber.toLowerCase().includes(searchTermLower) ||
            account.Name.toLowerCase().includes(searchTermLower) ||
            account.Location.toLowerCase().includes(searchTermLower)
        );
        if (matchingAccounts.length === 0) {
            this.noResultsFound = true;
        } else {
            this.accountDataSource = new MatTableDataSource<Account>(matchingAccounts);
            this.accountDataSource.paginator = this.accountPaginator;
        }
        // const matchingReports = this.reports.filter(report =>
        //     report.Name.toLowerCase().includes(searchTermLower)
        // );
    }

    async toggleReportSelection(report): Promise<void> {
        if (this.isAccountSelected) {
            // set spinner
            report.isSelected = !report.isSelected;
            await this._accountService.updateAccountReportLink(report.isSelected, this.currentAccount, report.report.Id).then
        }
    }

    async onAccountSelected(account: Account): Promise<void> {
        this.currentAccount = account;
        await firstValueFrom(this._accountService.getReportsForAccount(account.AccountNumber))
            .then((reportIds: string[]) => {
                // Reset all selections
                this.reports.forEach(r => r.isSelected = false);
                reportIds.forEach(id => {
                    const matchingReport = this.reports.find(r => r.report.Id === id);
                    if (matchingReport) {
                        matchingReport.isSelected = true;
                    }
                });
                // this.reportDataSource = new MatTableDataSource<ReportSelection>(this.reports);
            })
            .catch((error) => {
                console.error('Error fetching reports for account:', error);
                this.handleError(error);
            }
        );
    }
}
